import { SystemSettings } from "../Services/SystemSettingsService";

/** Default system settings — single source of truth for UI fallbacks. */
export const getDefaultSystemSettings = (tenantId: number): SystemSettings => ({
  tenantId,
  dateFormat: "M/d/yyyy",
  timeFormat: "12",
  timezone: "America/New_York",
  locale: "en-US",
  defaultCurrency: "USD",
  currencySymbol: "$",
  decimalPlaces: 2,
  decimalSeparator: ".",
  thousandsSeparator: ",",
  minPasswordLength: 8,
  requireUppercase: true,
  requireLowercase: true,
  requireNumbers: true,
  requireSpecialChars: false,
  passwordExpirationDays: 90,
  passwordHistoryCount: 5,
  sessionTimeoutMinutes: 30,
  maxConcurrentSessions: 3,
  failedLoginAttempts: 5,
  accountLockoutMinutes: 15,
  emailDeliveryMode: "Hosted",
  smtpServer: "",
  smtpPort: 587,
  smtpUseSsl: true,
  smtpUsername: "",
  smtpPassword: "",
  hasSmtpPassword: false,
  smtpFromEmail: "",
  smtpFromName: "",
  defaultPageSize: 10,
  enableEmailNotifications: true,
  enableInAppNotifications: true,
});

/** Common IANA timezones for the settings picker. */
export const SYSTEM_TIMEZONE_OPTIONS: { value: string; label: string }[] = [
  { value: "America/New_York", label: "Eastern Time (ET)" },
  { value: "America/Chicago", label: "Central Time (CT)" },
  { value: "America/Denver", label: "Mountain Time (MT)" },
  { value: "America/Los_Angeles", label: "Pacific Time (PT)" },
  { value: "America/Phoenix", label: "Arizona Time" },
  { value: "America/Anchorage", label: "Alaska Time" },
  { value: "Pacific/Honolulu", label: "Hawaii Time" },
  { value: "America/Toronto", label: "Canada — Eastern" },
  { value: "America/Vancouver", label: "Canada — Pacific" },
  { value: "Europe/London", label: "United Kingdom" },
  { value: "Europe/Paris", label: "Central Europe" },
  { value: "Europe/Berlin", label: "Germany" },
  { value: "Asia/Kolkata", label: "India (IST)" },
  { value: "Asia/Singapore", label: "Singapore" },
  { value: "Asia/Tokyo", label: "Japan" },
  { value: "Australia/Sydney", label: "Australia — Sydney" },
  { value: "UTC", label: "UTC" },
];
